import axios from 'axios';
import { API_URL, API_KEY, ENDPOINTS } from '../lib/constants';
import type { ParseDocResult } from '../types/parseDoc';

const api = axios.create({
    baseURL: API_URL,
    timeout: 300000,
    headers: { 'x-api-key': API_KEY },
});

export const parseDocument = async (
    file: File,
    options?: { retailerId?: string; systemPrompt?: string; section?: string; signal?: AbortSignal }
): Promise<ParseDocResult> => {
    if (!file) throw new Error('File is required');

    const formData = new FormData();
    formData.append('file', file);
    if (options?.retailerId) formData.append('retailerId', options.retailerId);
    if (options?.systemPrompt) formData.append('systemPrompt', options.systemPrompt);
    if (options?.section) formData.append('section', options.section);

    const response = await api.post<ParseDocResult>(
        ENDPOINTS.PARSEDOC_PARSE,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 300000, signal: options?.signal }
    );
    return response.data;
};
